import Phaser from 'phaser';
import { COLORS, DEPTHS, FONTS, GAME_HEIGHT, GAME_WIDTH, toHexColor } from '../config/gameConfig';

export class PauseScene extends Phaser.Scene {
  constructor() {
    super({ key: 'PauseScene' });
  }

  create(data?: { targetScene?: string }): void {
    const targetScene = data?.targetScene ?? 'DesktopScene';

    this.add
      .rectangle(0, 0, GAME_WIDTH, GAME_HEIGHT, COLORS.black, 0.65)
      .setOrigin(0, 0)
      .setDepth(DEPTHS.modal)
      .setInteractive(); // Trap clicks so they can't reach DesktopScene.

    const title = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 60, 'Paused', {
      fontFamily: FONTS.ui,
      fontSize: '28px',
      color: toHexColor(COLORS.textPrimary),
      fontStyle: 'bold',
    }).setOrigin(0.5).setDepth(DEPTHS.modal + 1);

    const sub = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 20, 'Take a minute. Nothing moves while paused.', {
      fontFamily: FONTS.ui,
      fontSize: '14px',
      color: toHexColor(COLORS.textMuted),
    }).setOrigin(0.5).setDepth(DEPTHS.modal + 1);

    const button = this.add
      .rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 40, 200, 40, COLORS.buttonPrimary)
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true })
      .setDepth(DEPTHS.modal + 1);
    const buttonLabel = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 40, 'Resume (ESC)', {
      fontFamily: FONTS.ui,
      fontSize: '14px',
      color: toHexColor(COLORS.buttonPrimaryText),
      fontStyle: 'bold',
    }).setOrigin(0.5).setDepth(DEPTHS.modal + 2);

    const resume = (): void => {
      this.scene.resume(targetScene);
      this.scene.stop();
    };
    button.on('pointerdown', resume);
    buttonLabel.setInteractive({ useHandCursor: true }).on('pointerdown', resume);
    this.input.keyboard?.on('keydown-ESC', resume);

    // Suppress unused-var warnings
    void title; void sub;
  }
}
